/*
 * @Author: wufan 
 * @Date: 2019-08-17 17:49:22 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-10-09 19:57:34
 */
import React, { useEffect, useState } from 'react';
import './QuestionDetailPage.less';
import AxiosTS from '../../core/axios';
import {
  withRouter
} from 'react-router-dom';
import XMTD from '../../core/xmTD';

const QuestionDetailPage: React.FC = (props: any) => {
  let id = props.location.pathname.indexOf('/', 5) !== -1 ? props.location.pathname.slice(props.location.pathname.indexOf('/', 5) + 1) : "";

  const [docId, setDocId] = useState(id);

  const [detailContent, setDetailContent] = useState({ questionTypeName: "", questionTitle: "", answerDesc: "", questionTypeId: "", questionId: "" });//搜索关键词结果问题列表
  const [subMenuData, setSubMenuData] = useState([]);// 上一条下一条数据
  const [subMenuTotal, setSubMenuTotal] = useState(-1);// 获取menu.Item 的数据总数
  const [subMenuPageNo, setSubMenuPageNo] = useState(1);
  const [hasResolved, setHasResolved] = useState(false);// 解决问题
  const [hasnotResolved, sethasnotResolved] = useState(false); //没有解决问题
  let newVersion = localStorage.getItem('newVersion');

  useEffect(() => {
    props.location.pathname !== "/detail" &&
      setDocId(id);
    setHasResolved(false);
    sethasnotResolved(false);
  }, [id])

  useEffect(() => {
    AxiosTS.sobot("query_doc_detail", {
      docId: docId,
      robotFlag: newVersion == 'true' ? 2 : 1,
    })
      .then((res: any) => {
        if (res.code === "1000") {
          setDetailContent(res.data.item);
        }
      })
      .catch((res: any) => {

      })

  }, [docId, newVersion])

  // 获取标题和内容
  let title: string = detailContent.questionTypeName;
  let contentString = detailContent.answerDesc.slice(0, detailContent.answerDesc.length - 1);

  useEffect(() => {
    subMenuData.length !== subMenuTotal
      && detailContent.questionTypeId &&
      AxiosTS.sobot("search_doc_list", {
        questionTypeId: detailContent.questionTypeId,
        robotFlag: newVersion == 'true' ? 2 : 1,
        keyFlag: 1,
        pageNo: subMenuPageNo,
        usedFlag: 0// 默认启用状态
      })
        .then((res: any) => {
          if (res.code === "1000") {
            let data: never[] = subMenuData.concat(res.data.items);
            let sortList: never[] = sortData(data);

            setSubMenuData(sortList);
            setSubMenuPageNo(preNo => preNo + 1);
            setSubMenuTotal(res.data.totalCount);
          }
        })
  }, [detailContent.questionTypeId, subMenuPageNo, newVersion])

  // 按数字序号从小到大排序
  function sortData(arr: never[]) {

    let newArr = arr.sort((a: { questionTitle: string }, b: { questionTitle: string }): any => {
      let AQuestionTitle = a.questionTitle;
      let BQuestionTitle = b.questionTitle;
      let firstNumbers = AQuestionTitle.slice(0, AQuestionTitle.indexOf("#"));
      let secondNumbers = BQuestionTitle.slice(0, BQuestionTitle.indexOf("#"));
      return Number(firstNumbers) - Number(secondNumbers)
    })
    return newArr;
  }

  function changeRouter() {
    props.history.push({
      pathname: `/entry/${detailContent.questionTypeId}`,
    })
  }

  // 打点
  function XMDataDot(name: string) {
    let paramList: any = JSON.parse(localStorage.getItem("ParamsFromB") || "");
    paramList.name = name;
    paramList.docId = docId;
    paramList.questionTitle = title + "——" + detailContent.questionTitle;
    XMTD(paramList);
  }

  // 点击已解决
  function handleHasResolve() {
    !hasnotResolved && setHasResolved(true);
    XMDataDot("B端-点击-帮助中心详情-已解决");
  }

  // 点击未解决
  function handleHasnotResolve() {
    !hasResolved && sethasnotResolved(true);
    XMDataDot("B端-点击-帮助中心详情-未解决");
  }

  function clickBtn(e: any) {
    const btn: any = document.getElementById("btn");
    btn.click();
  };

  let currentItemIndex: number = -1;
  subMenuData.map((item: any, index: number) => {
    if (item.questionId === detailContent.questionId) {
      currentItemIndex = index;
    }
  });

  let preItem: { questionTitle: string, docId: string } = subMenuData[currentItemIndex - 1];
  let nextItem: { questionTitle: string, docId: string } = subMenuData[currentItemIndex + 1];
  return (
    <div className="question-detail-page">
      <div className="question-detail-title">
        {<span className="keyword-cls" onClick={changeRouter}>{title}</span>}{' / 正文'}
      </div>
      <div className="question-detail-content">
        <div className="content-title">
          {detailContent.questionTitle}
        </div>
        <div className="context" dangerouslySetInnerHTML={{ __html: contentString }}>
        </div>
      </div>
      <div className="feedback-box">
        <span className="feedback-question">
          以上内容是否解决了您的问题？
      </span>
        <span className={` ${hasResolved ? "resolved" : "has-resolved"}`} onClick={() => handleHasResolve()}>
          <svg className="icon-symbol" aria-hidden="true">
            <use href="#iconicon_smile" className="iconicon_smile"></use>
          </svg>
          <span className="text">已解决</span>
        </span>

        <span className={` ${hasnotResolved ? "noresolved" : "hasnot-resolve"}`} onClick={handleHasnotResolve}>
          <svg className="icon-symbol" aria-hidden="true">
            <use href="#iconsad" className="iconsad"></use>
          </svg>
          <span className="text">未解决</span>
        </span>
      </div>
      {
        (hasResolved || hasnotResolved) &&
        <div className="say">
          {
            hasResolved &&
            <span className="resolve">
              <svg className="icon-symbol" aria-hidden="true">
                <use href="#iconicon_fankuitishi"></use>
              </svg>
              <span className="text">谢谢您的认可</span>
            </span>
          }
          {
            hasnotResolved &&
            <span className="noresolve">
              <svg className="icon-symbol" aria-hidden="true">
                <use href="#iconyiwentixinglei-teshu"></use>
              </svg>
              <span className="text">未解决问题？咨询在线客服为您解答</span>
              <span className="kefu" onClick={clickBtn} style={{ cursor: "pointer" }}>咨询</span>
            </span>
          }
        </div>
      }

      {(preItem || nextItem) &&
        <div className="bottom-pre-next">
          <div className="pre" onClick={() => {
            props.history.push({
              pathname: `/detail/${preItem.docId}`,
            })
          }}>{currentItemIndex !== -1 && preItem && `< 上一篇：${preItem.questionTitle}`}
          </div>
          <div className="next" onClick={() => {
            props.history.push({
              pathname: `/detail/${nextItem.docId}`,
            })
          }}>{currentItemIndex !== -1 && nextItem && `下一篇：${nextItem.questionTitle}＞`}</div>
        </div>
      }
    </div>
  )
}

export default withRouter(QuestionDetailPage);